// extracted by mini-css-extract-plugin
export var acitonButtons = "_ia-0";
export var additionalIcon = "_ia-f";
export var block = "_ia-1";
export var blockContent = "_ia-7";
export var blockDescription = "_ia-8";
export var blockIcon = "_ia-9";
export var blockTitle = "_ia-6";
export var border = "_ia-a";
export var center = "_ia-l";
export var edge = "_ia-b";
export var edgeLabel = "_ia-c";
export var edgePath = "_ia-d";
export var error = "_ia-e";
export var flowchart = "_ia-g";
export var flowchartContent = "_ia-h";
export var highlighted = "_ia-3";
export var hover = "_ia-4";
export var icon = "_ia-i";
export var left = "_ia-m";
export var navButton = "_ia-j";
export var navButtons = "_ia-k";
export var right = "_ia-n";
export var selected = "_ia-2";
export var small = "_ia-5";